import { Injectable, OnDestroy, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FomoService implements OnDestroy {
  count = signal<number>(Math.floor(Math.random() * 31) + 100); // 100~130명
  isAnimating = signal<boolean>(false);

  private timeoutId: ReturnType<typeof setTimeout> | null = null;
  private started = false;

  start() {
    if (this.started) return;
    this.started = true;
    this.scheduleNext();
  }

  stop() {
    this.started = false;
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  private scheduleNext() {
    const delay = Math.random() * 60000 + 30000; // 30~90초
    this.timeoutId = setTimeout(() => {
      if (!this.started) return;
      // 80% 확률로 +1, 20% 확률로 -1 (최솟값 100 유지)
      const delta = Math.random() < 0.8 ? 1 : -1;
      this.isAnimating.set(true);
      this.count.update(v => Math.max(100, v + delta));
      setTimeout(() => this.isAnimating.set(false), 500);
      this.scheduleNext();
    }, delay);
  }

  ngOnDestroy() {
    this.stop();
  }
}
